// extracted by mini-css-extract-plugin
export default {"NotificationAllowedContainer":"NotificationPermissionHandler_NotificationAllowedContainer__-7b8f"};